import { userConstants } from '../constants/user.constants';
import userService from '../services/user.service';
import { alertActions } from './alert.actions';
import { history } from '../helpers';
import { b64toBlob } from '../helpers/base64';

export const userActions = {
  login,
  logout,
  create,
  update,
  remove,
  unblock,
  unblockAll,
  fetch,
  createGroup,
  updateGroup,
  removeGroup,
  fetchGroups,
  getGroup,
  syncGroupAzureAd,
  syncGroupAd,
  managers,
  subordinates,
  get,
  me,
  status,
  importUsers,
  importBlock,
  importExternalId,
  importGroup
};

function login (email, password) {
  return async dispatch => {
    try {
      dispatch(request());
      const user = await userService.login(email, password);
      dispatch(me());
      dispatch(success(user));
      history.push('/');
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request(user) { return { type: userConstants.LOGIN_REQUEST, user }; }
  function success(user) { return { type: userConstants.LOGIN_SUCCESS, user} }
  function failure(error) { return { type: userConstants.LOGIN_FAILURE, error } }
}

function logout() {
  return async dispatch => {
    try {
      localStorage.clear();
      dispatch(success());
      history.push('/login');
    } catch(error) {
      return error;
    }
  };

  function success() { return { type: userConstants.LOGOUT } }
}

function create (obj) {
  return async dispatch => {
    dispatch(request());

    try {
      const user = await userService.create(obj);
      dispatch(success(user));
      dispatch(alertActions.success("Usuário criado"));
      history.push('/users');
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: userConstants.CREATE_REQUEST } }
  function success(user) { return { type: userConstants.CREATE_SUCCESS, user } }
  function failure(error) { return { type: userConstants.CREATE_FAILURE, error } }
}


function update (id, obj) {
  return async dispatch => {
    dispatch(request());

    try {
      const user = await userService.update(id, obj);
      dispatch(success(user));
      history.push('/users');
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: userConstants.UPDATE_REQUEST } }
  function success(user) { return { type: userConstants.UPDATE_SUCCESS, user } }
  function failure(error) { return { type: userConstants.UPDATE_FAILURE, error } }
}

function remove(id) {
  return async dispatch => {
    dispatch(request());
    try {
      await userService.remove(id);
      dispatch(success(true));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: userConstants.REMOVE_REQUEST } }
  function success(user) { return { type: userConstants.REMOVE_SUCCESS, user } }
  function failure(error) { return { type: userConstants.REMOVE_FAILURE, error } }
}

function unblock(id) {
  return async dispatch => {
    dispatch(request());
    try {
      await userService.unblock(id);
      dispatch(success(true));
      dispatch(alertActions.success("Bloqueios do usuário removidos"));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: userConstants.REMOVE_REQUEST } }
  function success(user) { return { type: userConstants.REMOVE_SUCCESS, user } }
  function failure(error) { return { type: userConstants.REMOVE_FAILURE, error } }
}

function welcomeEmail(username, resetPassword) {
  return async dispatch => {
    dispatch(request());
    try {
      await userService.unblock(id);
      dispatch(success(true));
      dispatch(alertActions.success("E-mail de boas-vindas enviado"));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: userConstants.WELCOME_EMAIL_REQUEST } }
  function success(user) { return { type: userConstants.WELCOME_EMAIL_SUCCESS, user } }
  function failure(error) { return { type: userConstants.WELCOME_EMAIL_FAILURE, error } }
}

function unblockAll() {
  return async dispatch => {
    dispatch(request());
    try {
      await userService.unblockAll();
      dispatch(success(true));
      dispatch(alertActions.success("Bloqueios de usuários removidos"));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: userConstants.REMOVE_REQUEST } }
  function success(user) { return { type: userConstants.REMOVE_SUCCESS, user } }
  function failure(error) { return { type: userConstants.REMOVE_FAILURE, error } }
}

function fetch(params) {
  return async dispatch => {      
    dispatch(request());

    try {
      const users = await userService.fetch(params);

      if (params.export && users.file) {        
        const blob = b64toBlob(users.file, {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        var csvURL = window.URL.createObjectURL(blob);
        var tempLink = document.createElement('a');
        tempLink.href = csvURL;
        tempLink.setAttribute('download', 'usuarios.xlsx');
        tempLink.click();
      }

      dispatch(success(users));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: userConstants.FETCH_REQUEST } }
  function success(users) { return { type: userConstants.FETCH_SUCCESS, users } }
  function failure(error) { return { type: userConstants.FETCH_FAILURE, error } }
}

function createGroup(obj) {
  return async dispatch => {
    dispatch(request());

    try {
      const group = await userService.createGroup(obj);
      dispatch(success(group));
      dispatch(alertActions.success("Grupo criado"));
      history.push('/groups');
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: userConstants.CREATE_GROUP_REQUEST } }
  function success(group) { return { type: userConstants.CREATE_GROUP_SUCCESS, group } }
  function failure(error) { return { type: userConstants.CREATE_GROUP_FAILURE, error } }
}

function syncGroupAzureAd(id) {
  return async dispatch => {
    dispatch(request());

    try {
      const group = await userService.syncGroupAzureAd(id);
      dispatch(success(group));
      dispatch(alertActions.success("Sincronização Iniciada. Verifique os logs em Relatórios - Logs Integração"));
      history.push('/groups');
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: userConstants.SYNC_GROUP_AZURE_REQUEST } }
  function success(groupSync) { return { type: userConstants.SYNC_GROUP_AZURE_SUCCESS, groupSync } }
  function failure(error) { return { type: userConstants.SYNC_GROUP_AZURE_FAILURE, error } }
}

function syncGroupAd(id) {
  return async dispatch => {
    dispatch(request());

    try {
      const group = await userService.syncGroupAd(id);
      dispatch(success(group));
      dispatch(alertActions.success("Grupo Sincronizado"));
      history.push('/groups');
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: userConstants.SYNC_GROUP_AD_REQUEST } }
  function success(groupSync) { return { type: userConstants.SYNC_GROUP_AD_SUCCESS, groupSync } }
  function failure(error) { return { type: userConstants.SYNC_GROUP_AD_FAILURE, error } }
}

function updateGroup(id, obj) {
  return async dispatch => {
    dispatch(request());

    try {
      const group = await userService.updateGroup(id, obj);
      dispatch(success(group));
      history.push('/groups');
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: userConstants.UPDATE_GROUP_REQUEST } }
  function success(group) { return { type: userConstants.UPDATE_GROUP_SUCCESS, group } }
  function failure(error) { return { type: userConstants.UPDATE_GROUP_FAILURE, error } }
}

function removeGroup(id) {
  return async dispatch => {
    dispatch(request());
    try {
      await userService.removeGroup(id);
      dispatch(success(true));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: userConstants.REMOVE_GROUP_REQUEST } }
  function success(group) { return { type: userConstants.REMOVE_GROUP_SUCCESS, group } }
  function failure(error) { return { type: userConstants.REMOVE_GROUP_FAILURE, error } }
}

function fetchGroups(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const groups = await userService.fetchGroups(params);

      dispatch(success(groups));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: userConstants.FETCH_GROUP_REQUEST } }
  function success(groups) { return { type: userConstants.FETCH_GROUP_SUCCESS, groups } }
  function failure(error) { return { type: userConstants.FETCH_GROUP_FAILURE, error } }
}

function managers(params) {
  return async dispatch => {
    dispatch(request());
    if (!params) {
      params = {};
    }
    params.active = 1;
    try {
      const managers = await userService.fetchManagers(params);
      dispatch(success(managers));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: userConstants.MANAGERS_REQUEST } }
  function success(managers) { return { type: userConstants.MANAGERS_SUCCESS, managers } }
  function failure(error) { return { type: userConstants.MANAGERS_FAILURE, error } }
}

function subordinates(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const subordinates = await userService.subordinates(params);

      dispatch(success(subordinates));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: userConstants.SUBORDINATES_REQUEST } }
  function success(subordinates) { return { type: userConstants.SUBORDINATES_SUCCESS, subordinates } }
  function failure(error) { return { type: userConstants.SUBORDINATES_FAILURE, error } }
}

function get(id) {
  return async dispatch => {
    dispatch(request());

    try {
      const user = await userService.get(id);
      dispatch(success(user));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: userConstants.GET_REQUEST } }
  function success(user) { return { type: userConstants.GET_SUCCESS, user } }
  function failure(error) { return { type: userConstants.GET_FAILURE, error } }
}

function getGroup(id) {
  return async dispatch => {
    dispatch(request());

    try {
      const group = await userService.getGroup(id);
      dispatch(success(group));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: userConstants.GET_GROUP_REQUEST } }
  function success(group) { return { type: userConstants.GET_GROUP_SUCCESS, group } }
  function failure(error) { return { type: userConstants.GET_GROUP_FAILURE, error } }
}

function me() {
  return async dispatch => {
    dispatch(request());

    try {
      const user = await userService.me();
      dispatch(success(user));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: userConstants.ME_REQUEST } }
  function success(me) { return { type: userConstants.ME_SUCCESS, me } }
  function failure(error) { return { type: userConstants.ME_FAILURE, error } }
}

function status(username) {
  return async dispatch => {
    dispatch(request());

    try {
      const status = await userService.status(username);
      dispatch(success(status));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: userConstants.STATUS_REQUEST } }
  function success(status) { return { type: userConstants.STATUS_SUCCESS, status } }
  function failure(error) { return { type: userConstants.STATUS_FAILURE, error } }
}

function importUsers(file) {
  return async dispatch => {
    dispatch(request());

    try {
      const result = await userService.importUsers(file);
      dispatch(success(result));
      dispatch(alertActions.success("Usuários Importados"));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: userConstants.IMPORT_REQUEST } }
  function success(result) { return { type: userConstants.IMPORT_SUCCESS, result } }
  function failure(error) { return { type: userConstants.IMPORT_FAILURE, error } }
}

function importBlock(file) {
  return async dispatch => {
    dispatch(request());

    try {
      const result = await userService.importBlock(file);
      dispatch(success(result));
      dispatch(alertActions.success("Bloqueio de Usuários Importados"));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: userConstants.IMPORT_REQUEST } }
  function success(result) { return { type: userConstants.IMPORT_SUCCESS, result } }
  function failure(error) { return { type: userConstants.IMPORT_FAILURE, error } }
}

function importExternalId(file) {
  return async dispatch => {
    dispatch(request());

    try {
      const result = await userService.importExternalId(file);
      dispatch(success(result));
      dispatch(alertActions.success("ID Externo de Usuários Importados"));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: userConstants.IMPORT_REQUEST } }
  function success(result) { return { type: userConstants.IMPORT_SUCCESS, result } }
  function failure(error) { return { type: userConstants.IMPORT_FAILURE, error } }
}

function importGroup(file) {
  return async dispatch => {
    dispatch(request());

    try {
      const result = await userService.importGroup(file);
      dispatch(success(result));
      dispatch(alertActions.success("Grupos Importados"));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: userConstants.IMPORT_REQUEST } }
  function success(result) { return { type: userConstants.IMPORT_SUCCESS, result } }
  function failure(error) { return { type: userConstants.IMPORT_FAILURE, error } }
}

